import React from 'react';
import './ExtraSectionFir.css'
const ExtraSectionFirs = () => {
    return (
        <div className='container mt-5'>
          <div className='row'>

          <div className='col-sm-12 col-lg-7 div'>
                <img className='img' src="https://i.ibb.co/5M9yyJW/motorcycle-with-helmet-1.png" alt="" />
            </div>
            <div className='col-sm-12 col-lg-5 mt2 bestbike '>
                  
                  <h3>This is best bike in our warehouse</h3>
                  <p>Bmw ks1130s is higher cc bike in bangladesh.most favorite
                    bike in biker . This bike top speed 300+..Now eid spacail offer..harray up!

                  </p>
                     

            </div>


            {/* https://i.ibb.co/gT8zqHd/black-motorcycle-white.png */}
          </div>

        </div>
    );
};

export default ExtraSectionFirs;